import React from 'react';
import { Column } from 'react-table';
import moment from 'moment';

import CobuTable from '../CobuTable/CobuTable';
import { ReactComponent as Community } from '~/utils/images/community.svg';
import { PausedResidentType } from '~/types/resident';

interface IProps {
  data: PausedResidentType[];
  onResume: (userId: string, rrUuid: string) => void;
  onChangePauseDate: (userId: string, pausedUntil: string) => void;
}

const PausedResidentsTable = (props: IProps) => {
  const { data, onResume, onChangePauseDate } = props;
  const tableData = React.useMemo(() => data, [data]);

  const columns = React.useMemo(
    () =>
      [
        {
          Header: 'NAME',
          accessor: (row: PausedResidentType) => `${row.firstName} ${row.lastName}`
        },
        {
          Header: 'EMAIL',
          accessor: (row: PausedResidentType) => row.email
        },
        {
          Header: 'PAUSED UNTIL',
          id: 'PAUSED_UNTIL',
          accessor: (row: PausedResidentType) =>
            moment(row.pausedUntil).format('MM/DD/YYYY')
        },
        {
          id: 'resume',
          accessor: (row: PausedResidentType) => (
            <div
              className='table-button pointer'
              onClick={() => onResume(row.user, row.rr_uuid)}
            >
              RESUME
            </div>
          )
        },
        {
          id: 'change-pause-date',
          accessor: (row: PausedResidentType) => (
            <div
              className='table-button pointer'
              onClick={() => onChangePauseDate(row.user, row.pausedUntil)}
            >
              CHANGE PAUSE DATE
            </div>
          )
        }
      ] as Column<PausedResidentType>[],
    [data]
  );

  return (
    <div>
      {tableData.length > 0 && (
        <div style={{ display: 'flex' }}>
          <CobuTable
            columns={columns}
            data={tableData}
            sort={{ id: 'PAUSED_UNTIL', descending: false }}
            hideRightBorder={false}
          />
        </div>
      )}
      {tableData.length === 0 && (
        <div className='noData'>
          <Community />
          <h2>No paused residents</h2>
        </div>
      )}
    </div>
  );
};

export default PausedResidentsTable;
